import { useT } from "@/app/hooks/useT";
interface NoDataFoundProps {
  message?: string;
  className?: string;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({
  message = "noDataFound",
  className = "",
}) => {
  const t = useT();
  return (
    <div className={`${className}`}>
      <p className="text-gray-500 text-lg font-semibold">{t(message)}</p>
    </div>
  );
};

export default NoDataFound;
